export default __webpack_public_path__ + "static/media/logo-card-1920w.86a375cc.png";